/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Submissions_ProInputs */

const en_landing_pricing_compare_submissions_pro = /** @type {(inputs: Landing_Pricing_Compare_Submissions_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 / month`)
};

const zh_landing_pricing_compare_submissions_pro = /** @type {(inputs: Landing_Pricing_Compare_Submissions_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月 10 次`)
};

/**
* | output |
* | --- |
* | "10 / month" |
*
* @param {Landing_Pricing_Compare_Submissions_ProInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_submissions_pro = /** @type {((inputs?: Landing_Pricing_Compare_Submissions_ProInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Submissions_ProInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_submissions_pro(inputs)
	return zh_landing_pricing_compare_submissions_pro(inputs)
});
export { landing_pricing_compare_submissions_pro as "landing.pricing.compare_submissions_pro" }